import { useCallback, useEffect, useState } from 'react';

import { ProfileEditModal } from './components/profile-edit.modal';

import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { useSession } from '../../../../hooks/useSession';
import { getAppState, setIsProfileModalOpen, setIsProfileEditMode } from '../../../../redux';

export function Profile() {
  const { sessionPerson } = useSession();

  const { isProfileModalOpen, isProfileEditMode } = useAppSelector(getAppState);
  const dispatch = useAppDispatch();

  const handleCloseProfileModal = useCallback(() => {
    dispatch(setIsProfileModalOpen(false));
    dispatch(setIsProfileEditMode(false));
  }, [dispatch]);

  const [editing, setEditing] = useState<boolean>(false);

  const handleStopEditing = useCallback(() => {
    setEditing(false);
    dispatch(setIsProfileEditMode(false));
    dispatch(setIsProfileModalOpen(false));
  }, [dispatch]);

  useEffect(() => {
    if (editing && sessionPerson?.id == null) {
      setEditing(false);
    }
    if (editing && !isProfileModalOpen) {
      setEditing(false);
    }
  }, [editing, sessionPerson?.id, isProfileModalOpen]);

  // Set editing mode based on Redux state
  useEffect(() => {
    if (isProfileEditMode) {
      setEditing(true);
    }
  }, [isProfileEditMode]);

  return (
    <>
      {/* Always show edit modal directly - no view-only modal needed */}
      {isProfileModalOpen && <ProfileEditModal open={true} onAfterSubmit={handleStopEditing} onClose={handleStopEditing} />}
    </>
  );
}
